import { Environment } from '@coolblue-development/constants';
import { RequestContextHeader as Header } from '@coolblue-development/next-request-context-utils';
import { headers } from 'next/headers.js';
export const getHeaders = () => {
    const result = Object.fromEntries(headers().entries());
    if (!isDevelopment()) {
        return result;
    }
    return {
        ...result,
        [Header.ATTEMPT_ID]: 'this-is-an-attempt-id',
        [Header.CLIENT_IP]: '127.0.0.1',
        [Header.CLOUDFRONT_REQUEST_ID]: 'this-is-a-request-id',
        [Header.COOLBLUE_SESSION_ID]: 'this-is-a-session-id',
        [Header.CORRELATION_ID]: 'this-is-a-correlation-id',
        [Header.IS_COOLBLUE_USER]: 'true',
    };
};
export const getHeader = (name) => {
    return getHeaders()[name];
};
const isDevelopment = () => {
    return process.env.ENVIRONMENT === Environment.DEVELOPMENT;
};
//# sourceMappingURL=getHeaders.js.map